import * as constants from '../constants';
import { ACTION } from './index';

export const setUiData = (payload: { isMobile: boolean }) => ({
  type: constants.SET_UI_DATA,
  payload,
});

export const setLoading = (payload: Object): ACTION => ({
  type: constants.LOADING,
  payload,
});
